import { FC } from 'react'
import { IconPaths, PrescricaoType } from '_metronic/helpers'
import { DocumentoPrevisto, ORDEM_TIPOS_DOCUMENTO } from '../../core/montagem/documentos'
import { ItemPrescricao, rotuloCatalogo } from '../../core/montagem/itens'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { SeloSncr, SeloValidade } from '../comum/Selos'
import { useRotulos } from '../comum/useRotulos'

/** Prévia dos documentos que a assinatura vai gerar, agrupados por tipo. */
export const SecaoDocumentos: FC<{ documentos: DocumentoPrevisto[] }> = ({ documentos }) => {
  const { t, tituloDocumento } = useRotulos()

  const linhaDoItem = (item: ItemPrescricao) => {
    switch (item.categoria) {
      case PrescricaoType.Orientacoes:
        return item.catalogo.nome
      case PrescricaoType.Exame:
        return item.catalogo.nome
      default:
        return [
          rotuloCatalogo(item.catalogo),
          item.posologia || t('prescricao.item.sem_posologia'),
          item.quantidade,
          item.categoria === PrescricaoType.Medicamento && item.usoContinuo
            ? t('prescricao.item.uso_continuo').toLowerCase()
            : '',
        ]
          .filter(Boolean)
          .join(' · ')
    }
  }

  return (
    <section aria-labelledby='revisao-documentos' className={styles.secao}>
      <h3 id='revisao-documentos' className='fs-6 fw-bold mb-3'>
        {t('prescricao.revisao.documentos', { quantidade: documentos.length })}
      </h3>
      <div className='d-flex flex-column gap-4'>
        {ORDEM_TIPOS_DOCUMENTO.map((tipo) => {
          const doTipo = documentos.filter((documento) => documento.tipo === tipo)
          if (doTipo.length === 0) return null
          return (
            <div key={tipo}>
              <span
                className={`d-block fs-8 fw-bold text-uppercase mb-2 ${styles.textoSecundario}`}
              >
                {t(`prescricao.documento.grupo.${tipo}`)}
                {doTipo.length > 1 && ` · ${doTipo.length}`}
              </span>
              <ul className='list-unstyled m-0 d-flex flex-column gap-2'>
                {doTipo.map((documento) => (
                  <li key={documento.chave} className={styles.documento}>
                    <Icone icone={IconPaths.Pdf} className='mt-1 fs-3' />
                    <div className={`d-flex flex-column gap-1 ${styles.encolhe}`}>
                      <span className='fw-bold'>{tituloDocumento(documento)}</span>
                      <span className={`fs-7 ${styles.textoSecundario}`}>
                        {documento.itens.map(linhaDoItem).join(' | ')}
                      </span>
                      {(documento.validadeDias || documento.sncr) && (
                        <span className='d-flex flex-wrap gap-1'>
                          {documento.validadeDias && (
                            <SeloValidade
                              texto={t('prescricao.documento.validade_dias', {
                                dias: documento.validadeDias,
                              })}
                            />
                          )}
                          {documento.sncr && <SeloSncr tipo={documento.sncr} />}
                        </span>
                      )}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )
        })}
      </div>
    </section>
  )
}
